import { Grid } from "@mui/material";
import styled from "styled-components";

export const ClientesContainer = styled(Grid)`
    height: 100%;
`;